import { render, staticRenderFns } from "./ActionSize.vue?vue&type=template&id=14609956&scoped=true"
import script from "./ActionSize.vue?vue&type=script&lang=js"
export * from "./ActionSize.vue?vue&type=script&lang=js"
import style0 from "./ActionSize.vue?vue&type=style&index=0&id=14609956&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14609956",
  null
  
)

export default component.exports